import { generateProductKey } from "./toshiba-utils";

export const DEFAULT_NAVIGATION_GUARD =
   'Are you sure you want to leave this page? You will lose any unsaved changes for the current step.' as const;

export enum STEPS {
   STEP_1 = 1,
   STEP_2 = 2,
   STEP_3 = 3,
   STEP_4 = 4,
   STEP_5 = 5,
   STEP_6 = 6,
   STEP_7 = 7,
};

export const TOTAL_STEPS = 7 as const;

export enum CLAIM_STEPS {
   STEP_1 = 1,
   STEP_2 = 2,
   STEP_3 = 3,
   STEP_4 = 4,
};

export const CLAIM_TOTAL_STEPS = 4 as const;

export const MAX_APPLIANCES = 10 as const;

export const TEN_MINUTES = 10 / (24 * 60);

export const MIN_NUMBER_OF_UNITS = {
   RAS_SINGLE: 2,
   RAS_MULTI: 3,
   RAV_SINGLE: 2,
   RAV_MULTI: 3, 
   VRF: {
      INDOOR: 1,
      OUTDOOR: 1,
      TOTAL: 2,
   },
   ESTIA: {
      DOMESTIC_HOT_WATER_NOT_FITTED: 2,
      DOMESTIC_HOT_WATER_FITTED: 3,
   },
   GENERIC: 2,
   A2A: 1,
} as const;

export enum QUERY_KEYS {
   PROPERTY_TYPES = 'property_types',
   CONTACT_TITLES = 'contact_titles',
   CONTACT_TYPES = 'contact_types',
   WORK_CATEGORIES = 'work_categories',
   PRODUCT_LOCATIONS = 'product_locations',
   MERCHANTS = 'merchants',
   CUSTOMERS = 'customer_companies',
   INSTALLER_USERS = 'installer_users',
   INSTALLER_COMPANIES = 'installer_companies',
   PRODUCT_PARENTS = 'product_parents',
   PRODUCT_CHILDREN = 'product_children',
   PRODUCT_TYPES = 'product_types',
   PRODUCT_LINES = 'product_lines',
   DISTRIBUTORS = 'distributors',
    PRODUCT_MODELS = 'product_models',
    INSTALLATIONS = 'installations',
    INSTALLATION_SYSTEMS = 'installation_systems',
};

export enum SYSTEM_TYPES {
   GAS_BOILER = 'gas_boiler',
   HEAT_PUMPS = 'heat_pump',
   SOLAR = 'solar',
   ELECTRIC_BOILER = 'electric_boiler',
}

export enum STATUS_TYPES {
   COMPLETED = 'completed',
   IN_PROGRESS = 'in_progress',
   CANCELLED = 'cancelled',
   SUBMITTING = 'submitting',
}

export enum MERCHANT_IDS {
   OTHER = 'other',
}

// Keep in sync with ViessmannWarrantyUpliftRequest::ALLOWED_YEARS on the API.
export const UPLIFT_YEARS = [2, 3, 5, 7, 10, 12];
export const VIPARTNER_YEARS = 7;

export enum SERIAL_NUMBER_CATEGORIES {
   CARRIER = 19,
   VIESSMANN = 16
}

export enum PRODUCT_CHILDREN {
   VRF = 'VRF',
   A2A = 'A2A',
   ESTIA = 'Estia',
   RAV_SINGLE = 'RAV Single',
   RAV_MULTI = 'RAV Multi',
   RAS_SINGLE = 'RAS Single',
   RAS_MULTI = 'RAS Multi',
}

export enum PRODUCT_TYPES {
   INDOORS = 'Indoors',
   OUTDOORS = 'Outdoors',
   STANDALONE = 'Standalone',
}

export enum PRODUCT_LINES {
   OUTDOOR = 'Outdoor',
   HYDRO = 'Hydro',
   CYLINDER = 'Cylinder',
}

export enum DISTRIBUTOR_CLAIM_TYPES {
   POST_REPAIR = 'claim_post_repair',
   PRE_REPAIR = 'claim_pre_repair',
}

export const MAX_TEXT_LENGTH = 100;

interface ProductModuleConfig {
   isA2A?: boolean;
   product_type_id?: string;
   product_line_id?: string;
   product_id?: string;
}

export class ProductModule {
   constructor(config: ProductModuleConfig = {}) {
      this.key = generateProductKey();
      this.product_type_id = config.product_type_id || '';
      this.product_line_id = config.product_line_id || '';
      this.product_id = config.product_id || '';
      this.serial_number = '';
      this.installation_location = '';
      this.water_circuit_description = '';
      this.is_a2a = config.isA2A || false;
   }

   key: string;
   product_type_id: string;
   product_line_id: string;
   product_id: string;
   serial_number: string;
   installation_location: string;
   water_circuit_description: string;
   is_a2a: boolean;
};

export class ClaimPartModule {
   constructor() {
      this.key = generateProductKey();
      this.part_number = '';
      this.description = '';
      this.replacement_dispatch_note_number = '';
      this.fault_symptoms = '';
      this.repair_details = '';
      this.previously_repaired = false;
   }

   key: string;
   part_number: string;
   description: string;
   replacement_dispatch_note_number: string;
   fault_symptoms: string;
   repair_details: string;
   previously_repaired: boolean;
};